import { render, staticRenderFns } from "./communitystatistics.vue?vue&type=template&id=4b67828a&scoped=true&"
import script from "./communitystatistics.vue?vue&type=script&lang=js&"
export * from "./communitystatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b67828a",
  null
  
)

export default component.exports